import { z } from 'zod';
import { BasicAnimationSetSchema } from './animations';
import { BasePinComponentSchema, BasePinComponentSettingsSchema } from './base-pin-component';

export const VideoSourceSchema = z.enum(['YOUTUBE', 'VIMEO', 'SCHOOL_TV']);
export type VideoSource = z.infer<typeof VideoSourceSchema>;

const VideoSettingsSchema = BasePinComponentSettingsSchema.extend(
  z.object({
    source: VideoSourceSchema.optional(), // we support a empty placeholder
    sourceId: z.string().min(1).optional(),
    startTime: z.number().optional(),
    endTime: z.number().optional(),
    animations: BasicAnimationSetSchema.optional(),
  }).shape
);

export type VideoSettings = z.infer<typeof VideoSettingsSchema>;

export const VideoPinComponentTypeSchema = z.literal('VIDEO');

export const VideoPinComponentSchema = BasePinComponentSchema.extend(
  z.object({
    type: VideoPinComponentTypeSchema,
    settings: VideoSettingsSchema,
  }).shape
);
